export const MONITORING_TRANSLATION_NAMESPACE = "monitoring";

export const MONITORING_VIEW_TK = "MONITORING_VIEW_TK";
